import SystemFieldProto from '../../proto/system-field-proto';
import FieldTextViewInImport from "../../import/view-in-preview/long-text-view-in-preview";


export default class DescriptionField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);

        this.type = gd.const.fields.type.DESCRIPTION;
    }

    // get sortHintMessage() {
    //     return 'Sort by title';
    // }

    // getCsvValue(item) {
    //     return item.title;
    // }

    // listItemSortFunctions(sort) {
    //     return {
    //         functions: [i => i.getName().toLowerCase()],
    //         directions: [sort]
    //     }
    // }

    // IMPORT

    normalizeCSVValue(value) {
        return value?value.trim():null;
    }

    getComponentViewInImport() {
        return FieldTextViewInImport;
    }

}
